/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Activity_Center_Empty_StateInputs */



/**
* | output |
* | --- |
* | "No current activity" |
*
* @param {Activity_Center_Empty_StateInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const activity_center_empty_state = /** @type {((inputs?: Activity_Center_Empty_StateInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Activity_Center_Empty_StateInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Keine aktuellen Aktivitäten")
	return /** @type {LocalizedString} */ ("No current activity")
});